module.exports = __webpack_public_path__ + "img/geofolio-logo.a2803f49.svg";